import { graphql, useMutation } from "react-relay"
import { useRequestPatientRecordExportMutation as UseRequestPatientRecordExportMutation } from "@/modules/patients/detail/record-extract/services/__generated__/useRequestPatientRecordExportMutation.graphql"

const mutation = graphql`
  mutation useRequestPatientRecordExportMutation($input: Ch_requestPatientRecordExportInput!) {
    ch_requestPatientRecordExport(input: $input) {
      requestPatientRecordExportOutput {
        requestId
        status
      }
    }
  }
`

const useRequestPatientRecordExportMutation = () => useMutation<UseRequestPatientRecordExportMutation>(mutation)

export { useRequestPatientRecordExportMutation }
